/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Endpoint_Free_SampleInputs */

const en_app_endpoint_free_sample = /** @type {(inputs: App_Endpoint_Free_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free sample`)
};

const zh_hans1_app_endpoint_free_sample = /** @type {(inputs: App_Endpoint_Free_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费示例`)
};

const pt_br2_app_endpoint_free_sample = /** @type {(inputs: App_Endpoint_Free_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amostra grátis`)
};

const es_app_endpoint_free_sample = /** @type {(inputs: App_Endpoint_Free_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muestra gratis`)
};

const fr_app_endpoint_free_sample = /** @type {(inputs: App_Endpoint_Free_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exemple gratuit`)
};

const de_app_endpoint_free_sample = /** @type {(inputs: App_Endpoint_Free_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloses Beispiel`)
};

const ru_app_endpoint_free_sample = /** @type {(inputs: App_Endpoint_Free_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатный пример`)
};

const it_app_endpoint_free_sample = /** @type {(inputs: App_Endpoint_Free_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campione gratuito`)
};

/**
* | output |
* | --- |
* | "Free sample" |
*
* @param {App_Endpoint_Free_SampleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const app_endpoint_free_sample = /** @type {((inputs?: App_Endpoint_Free_SampleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Endpoint_Free_SampleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_app_endpoint_free_sample(inputs)
	if (locale === "pt-BR") return pt_br2_app_endpoint_free_sample(inputs)
	if (locale === "es") return es_app_endpoint_free_sample(inputs)
	if (locale === "fr") return fr_app_endpoint_free_sample(inputs)
	if (locale === "de") return de_app_endpoint_free_sample(inputs)
	if (locale === "ru") return ru_app_endpoint_free_sample(inputs)
	if (locale === "it") return it_app_endpoint_free_sample(inputs)
	return en_app_endpoint_free_sample(inputs)
});